<mat-toolbar color="accent">
    <mat-toolbar-row>
      <span>
        {{ subTitle }}
      </span>
      <span class="spacer"></span>
      <button mat-raised-button type="button" aria-label="Edit" (click)="handleBack()">
        <mat-icon>chevron_left</mat-icon>
      </button>
    </mat-toolbar-row>
</mat-toolbar>

<div class="flex-container">
    <form [formGroup]="codeForm" *ngIf="isFormLoaded()" (ngSubmit)="handleSubmit()" class="flex-item flex-container">

        <mat-form-field appearance="fill">
            <mat-label>Code</mat-label>
            <input matInput name="code" formControlName="code" maxlength="15" />
            <mat-error *ngIf="codeForm.controls['code'].hasError('required')">
                First name is required.
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>Code Type</mat-label>
            <mat-select name="code_type" formControlName="code_type">
                <mat-option *ngFor="let codeType of codeTypes" value="{{codeType.id}}">{{codeType.name}}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Code Order</mat-label>
          <input matInput name="code_order" formControlName="code_order" maxlength="50" />
          <mat-error *ngIf="codeForm.controls['code_order'].hasError('required')">
            Order is required.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Description</mat-label>
          <input matInput name="description" formControlName="description" maxlength="1024" />
          <mat-error *ngIf="codeForm.controls['description'].hasError('required')">
            Description is required.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Description (Long)</mat-label>
          <input matInput name="description_long" formControlName="description_long" maxlength="1024" />
          <mat-error *ngIf="codeForm.controls['description_long'].hasError('required')">
            Description is required.
          </mat-error>
        </mat-form-field>

        <div class="field-container">
            <mat-slide-toggle formControlName="is_active" class="slider-toggle" [checked]="false">Is code actively in use?</mat-slide-toggle>
        </div>
        
        <div class="controls">
            <button name="button-submit" [disabled]="getIsSubmitActive()"  mat-raised-button type="submit" color="primary">Submit</button>
        </div>
    </form>
</div>